var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from 'next-i18next';
import Modal from '@spa/shared/components/Modal';
import { GlobalModalStyle } from './styles';
import Section from './Section';
var Features = function Features(_ref) {
  var _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
    _ref$features = _ref.features,
    privateFeatures = _ref$features.privateFeatures,
    commonFeatures = _ref$features.commonFeatures;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasPrivateFeatures = privateFeatures && Object.values(privateFeatures).reduce(function (acc, unit) {
    return acc + unit.length;
  }, 0) > 0;
  var hasCommonFeatures = commonFeatures && Object.values(commonFeatures).reduce(function (acc, unit) {
    return acc + unit.length;
  }, 0) > 0;
  return __jsx(Modal, {
    className: "modal-features",
    onClose: onClose
  }, __jsx(GlobalModalStyle, null), hasPrivateFeatures ? __jsx(Section, {
    title: hasCommonFeatures ? t('features_modal.title.private_spaces') : null,
    features: privateFeatures
  }) : null, hasCommonFeatures ? __jsx(Section, {
    title: hasPrivateFeatures ? t('features_modal.title.shared_spaces') : null,
    features: commonFeatures
  }) : null);
};
export default Features;